import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useTranslation } from 'react-i18next';

interface Props {
    enableItemQty: number;
}

function EnabledItemsTitle({ enableItemQty }:Props) {
    const { t } = useTranslation('cart');
    return (
        <Row spacing={2}>
            <Text fontWeight='medium'>
                {t('items.orderItems')}
            </Text>
            <Text color={colors.textUnselected}>
                {t('items.total')} {enableItemQty.toLocaleString()}{t('items.count')}
            </Text>
        </Row>
    );
}

export default EnabledItemsTitle;
